module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE2IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNEOTMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDZjMCA3LTIuMSAxMC02IDEwLTMuOTEgMC02LTItNi0xMEgwYzAgOSAzIDEyIDcgMTJ2NC4wMWMtMy4zOS4wNy02IC40OS02IC45OSAwIC41NSAzLjEzIDEgNyAxczctLjQ1IDctMWMwLS41LTIuNjEtLjkyLTYtLjk5VjE4YzMgMCA3LTMgNy0xMmgtMnptLTYgOGMyLjQ5IDAgNC0xLjk3IDQtNUg4VjhoNFY3SDhWNmg0VjVIOFY0aDMuOTRDMTEuNjMgMS41NSAxMC4yIDAgOCAwIDUuNTEgMCA0IDEuOTcgNCA1djRjMCAzLjAzIDEuNTEgNSA0IDV6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/podcast.svg
// module id = m2zA
// module chunks = 0